// import React from "react";
// const ChangeLanguageFunctions = React.createContext({
// 	toEn: () => {
// 		console.log("未绑定函数");
// 	},
// 	toZh: () => {
// 		console.log("未绑定函数");
// 	},
// });
// export default ChangeLanguageFunctions;

import React from "react";
const ChangeLanguageFunctions = React.createContext();
export default ChangeLanguageFunctions;
